import { OrganizationIntegrationType } from '@breakoutlearning/firebase-repository/types'
import { noTry } from '@breakoutlearning/firebase-repository/util'
import { useCallback, useMemo, useState } from 'react'
import { z } from 'zod'

const baseKey = 'ltiMode'
const optionsKey = 'ltiModeOptions'

const ltiOptionsSchema = z.object({
  sectionId: z.string().optional(),
  organizationId: z.string().optional(),
  placement: z.string().optional(),
  ltiMode: z.nativeEnum(OrganizationIntegrationType),
})

type LTIOptions = z.infer<typeof ltiOptionsSchema>

export const useLTIMode = () => {
  const extractedOptions: LTIOptions | null = useMemo(() => {
    const rawOptions = sessionStorage.getItem(optionsKey)

    if (!rawOptions) return null

    const [parsed] = noTry<LTIOptions>(() => {
      const json = JSON.parse(rawOptions)

      return ltiOptionsSchema.parse(json)
    })

    if (!parsed) return null

    return parsed
  }, [])

  const [ltiMode, _setLTIMode] = useState(extractedOptions?.ltiMode)

  const [ltiOptions, setLTIOptions] = useState<LTIOptions | null>(
    extractedOptions
  )

  const setLTIMode = useCallback(
    (mode: OrganizationIntegrationType, options?: LTIOptions) => {
      if (mode) {
        if (options && Object.keys(options).length > 0) {
          setLTIOptions(options)
          sessionStorage.setItem(optionsKey, JSON.stringify(options))
        }

        sessionStorage.setItem(baseKey, 'true')
        _setLTIMode(mode)
      }
    },
    []
  )

  return {
    ltiOptions,
    ltiMode,
    ltiModeOn: Boolean(ltiMode),
    setLTIMode,
  }
}
